export enum PaywallABTestVariant {
  CLARA = "clara",
  ELEVENLABS = "elevenlabs",
}
